import { withCompInfo } from '@wix/editor-elements-integrations'
import { fontObjectToString, getScaledFont, parseFontStr } from '@wix/thunderbolt-becky-root'
import type { RatingsInputDefinition, RatingsInputCssCarmiData } from '@wix/thunderbolt-components-native'

const MOBILE_DEFAULT_FONT_SIZE = 13 // px

const scaledFont = (fontValue: string, scale: number = 1) => {
	const fontObject = parseFontStr(fontValue)
	const { size } = fontObject
	return fontObjectToString({
		...fontObject,
		size: size < MOBILE_DEFAULT_FONT_SIZE ? size * scale : MOBILE_DEFAULT_FONT_SIZE * scale,
	})
}

export const css = withCompInfo<RatingsInputCssCarmiData, RatingsInputDefinition>()(
	// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
	['compLayout', 'styleProperties', 'siteFonts', 'isMobileView', 'isOneDocMigrated'],
	// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
	({ compLayout, styleProperties, siteFonts, isMobileView, isOneDocMigrated }) => {
		const { scale } = compLayout
		const compInfo = { compLayout, styleProperties, siteFonts, isMobileView }
		const fontValue = getScaledFont(compInfo, 'labelFont', isOneDocMigrated)
		return {
			'--labelFont': isMobileView ? scaledFont(fontValue, scale) : fontValue,
		}
	}
)
